import { useAppSelector } from 'hooks/useAppSelector';
import { FC } from 'react';
import { fromSecondaryMarket } from 'state/selectors';

import { GenericErrorBoundary } from '../../common-form/builder/form/GenericErrorBoundary';
import { ConnectedCodeSearch } from './codeSearch';

import './index.css';
import { ConnectedResultsGrid } from './resultGrid';
import { SectionSubTitle, SectionTitle } from './SectionTitle';

interface SecondaryMarketProductSearchProps {}

export const SecondaryMarketProductSearch: FC<SecondaryMarketProductSearchProps> = () => {
  const items = useAppSelector(state => fromSecondaryMarket.productSearch.getSecondaryMarketProductSearchItems(state));

  return (
    <div className="d-flex flex-column vh-100">
      <div className="d-flex align-items-center gap-3 secondary-quote-header">
        <div className="d-flex align-items-center gap-3 flex-grow-1">
          <SectionTitle textKey="secondary-market-quotation.page.title" />
          <div className="vertical-divider"></div>
          <div className="d-flex align-items-center">
            <SectionSubTitle className="mb-3 " textKey="secondaryMarket.products.recentSearched" />
            <span className="ms-2 badge rounded-pill badge-info" data-e2e="recentSearchCount">
              {items.length}
            </span>
          </div>
        </div>
        <GenericErrorBoundary>
          <ConnectedCodeSearch />
        </GenericErrorBoundary>
      </div>
      <GenericErrorBoundary>
        <ConnectedResultsGrid />
      </GenericErrorBoundary>
    </div>
  );
};
